module.exports = __webpack_public_path__ + "static/media/A17.fccd229a.png";